import { render, staticRenderFns } from "./MasterCoursesBannerCard.vue?vue&type=template&id=ddeda288&lang=pug&"
import script from "./MasterCoursesBannerCard.vue?vue&type=script&lang=ts&"
export * from "./MasterCoursesBannerCard.vue?vue&type=script&lang=ts&"
import style0 from "./MasterCoursesBannerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
